exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-1488f954]{max-width:1280px;margin-left:auto;margin-right:auto;padding:2rem}.content[data-v-1488f954],.content main[data-v-1488f954]{margin-bottom:4rem}.content main .image[data-v-1488f954]{height:300px;width:300px;float:left;margin-right:2rem;margin-bottom:1.5rem;--bg-opacity:1;background-color:#e6242c;background-color:rgba(230,36,44,var(--bg-opacity));border-radius:.5rem}@media (max-width:640px){.content main .image[data-v-1488f954]{width:100%;margin-right:2rem;margin-bottom:1.5rem;--bg-opacity:1;background-color:#e6242c;background-color:rgba(230,36,44,var(--bg-opacity));border-radius:.5rem}}", ""]);

// exports
